import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import AddButton from '../../../components/AddButton';
import ModalDetail from '../../../components/DetailModal';
import SearchAdvance from '../../../components/SearchAdvance';
import SearchAdvanceForm from '../../../components/SearchAdvanceForm';
import SearchBar from '../../../components/SearchBar';
import PaginatedTable from '../../../components/PaginatedTable';
import DocumentPreview from '../../../components/Komisi/DocumentPreview';

const DataKomisi = () => {
  const [dataKomisi, setDataKomisi] = useState([]);
  const [search, setSearch] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [komisiGross, setKomisiGross] = useState('');
  const [komisiBersih, setKomisiBersih] = useState('');
  const [maxPremi, setMaxPremi] = useState('');
  const [maxLP, setMaxLP] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showFields, setShowFields] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem('komisi')) || [];
    setDataKomisi(stored);
  }, [location]);

  const filteredData = dataKomisi.filter((item) => {
    const tgl = item.tanggalAwal;

    if (fromDate && tgl < fromDate) return false;
    if (toDate && tgl > toDate) return false;
    if (komisiGross && !item.komisiGross?.toString().includes(komisiGross)) return false;
    if (komisiBersih && !item.komisiBersih?.toString().includes(komisiBersih)) return false;
    if (maxPremi && !item.maxPremi?.toString().includes(maxPremi)) return false;
    if (maxLP && !item.maxLP?.toString().includes(maxLP)) return false;

    if (search && ![item.tanggalAwal, item.tanggalAkhir, item.komisiGross, item.komisiBersih, item.maxPremi, item.maxLP].some((field) => field?.toString().toLowerCase().includes(search.toLowerCase()))) return false;

    return true;
  });

  const handleEdit = (index) => {
    const data = dataKomisi.find((item) => item === filteredData[index]);
    const realIndex = dataKomisi.findIndex((item) => item === filteredData[index]);
    localStorage.setItem('editKomisi', JSON.stringify({ ...data, index: realIndex }));
    navigate('/add-komisi');
  };

  const handleDelete = (index) => {
    if (window.confirm('Yakin ingin menghapus data ini?')) {
      const updated = [...dataKomisi];
      const realIndex = dataKomisi.findIndex((item) => item === filteredData[index]);
      updated.splice(realIndex, 1);
      setDataKomisi(updated);
      localStorage.setItem('komisi', JSON.stringify(updated));
    }
  };

  const handleView = (index) => {
    const selected = filteredData[index];
    if (selected) {
      setSelectedItem(selected);
      setShowDetailModal(true);
    }
  };

  const handleClearFilters = () => {
    setFromDate('');
    setToDate('');
    setKomisiGross('');
    setKomisiBersih('');
    setMaxPremi('');
    setMaxLP('');
  };

  const columns = [
    { key: 'tanggalAwal', label: 'Tanggal Awal' },
    { key: 'tanggalAkhir', label: 'Tanggal Akhir' },
    { key: 'komisiGross', label: 'Komisi Gross per Kg (Rp)' },
    { key: 'maxPremi', label: 'Max Premi per Kg (Rp)' },
    { key: 'maxLP', label: 'Max LP per Kg (Rp)' },
    { key: 'komisiBersih', label: 'Komisi Bersih per Kg (Rp)' },
    { key: 'document', label: 'Dokumen', render: (item) => <DocumentPreview document={item.document} /> },
  ];

  return (
    <div className="pt-10 pl-64">
      <h2 className="pl-6 mb-6 text-2xl font-semibold text-green-700">Data Komisi</h2>
      <div className="p-6 mx-4 bg-white shadow rounded-xl">
        <div className="flex items-center justify-between mb-4">
          <AddButton
  onClick={() => {
    localStorage.removeItem('editKomisi'); 
    navigate('/add-komisi');
  }}
   moduleName="Data Komisi"
/>

          <div className="flex items-center gap-2">
            <SearchBar value={search} onChange={setSearch} />
            <SearchAdvance showFields={showFields} toggleShowFields={() => setShowFields(!showFields)} />
          </div>
        </div>

        {showFields && (
          <SearchAdvanceForm
            dateFields={[
              {
                label: 'Tanggal Awal',
                fromValue: fromDate,
                toValue: toDate,
                onFromChange: setFromDate,
                onToChange: setToDate,
              },
            ]}
            additionalFields={[
              { label: 'Komisi Gross', value: komisiGross, onChange: setKomisiGross },
              { label: 'Komisi Bersih', value: komisiBersih, onChange: setKomisiBersih },
              { label: 'Max Premi', value: maxPremi, onChange: setMaxPremi },
              { label: 'Max LP', value: maxLP, onChange: setMaxLP },
            ]}
            onClear={handleClearFilters}
          />
        )}

        <PaginatedTable
          data={filteredData}
          columns={columns}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onView={handleView}
          moduleName="Data Komisi"
        />

        {showDetailModal && <ModalDetail data={selectedItem} onClose={() => setShowDetailModal(false)} />}
      </div>
    </div>
  );
};

export default DataKomisi;